import React, { useState } from 'react';
import { Dialog, Box } from '@mui/material';
import { ReactComponent as CloseMessage } from './images/close-message.svg';

const ImagePreviewModal = ({ imageUrl, open, onClose }) => {
  const [imageDimensions, setImageDimensions] = useState({
    width: 'auto',
    height: 'auto',
  });

  const handleImageLoad = (e) => {
    const { naturalWidth, naturalHeight } = e.target;
    setImageDimensions({
      width: naturalWidth + 100,
      height: naturalHeight + 100,
    });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          maxWidth: imageDimensions.width,
          maxHeight: imageDimensions.height,
          overflow: 'hidden',
          margin: '0 10px',
          borderRadius: '7px',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'end',
          alignItems: 'center',
          padding: 1,
          backgroundColor: '#21538F',
          color: 'white',
          height: '15px',
        }}
      >
        <div
          className="header-button"
          style={{ marginRight: '0' }}
          onClick={onClose}
        >
          <CloseMessage style={{ height: '10px' }} />
        </div>
      </Box>
      <img
        src={imageUrl}
        alt="photoPreview"
        onLoad={handleImageLoad}
        style={{ display: 'block', width: '100%', height: 'auto' }}
      />
    </Dialog>
  );
};

export default ImagePreviewModal;
